<template>
  <!--<footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a href="#" target="_blank" rel="nofollow">TogoCel</a>, Tous droits réservés</span>
    <span class="md:flex hidden items-center">
            <span>Par <a href="#">eBusiness Afrique</a></span>
        </span>
  </footer>-->
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a href="#" style="color: black; font-weight: bold" target="_blank" rel="nofollow">MTN</a>, Tous droits réservés</span>
    <span class="md:flex hidden items-center">
            <span>Par <a href="#" style="color: black; font-weight: bold">eBusiness Afrique</a></span>
        </span>
  </footer>
</template>

<script>
  export default {
    name: "the-footer",
    props: {
      classes: {
        type: String,
      },
    }
  }
</script>
